import * as Yup from "yup";

export const addSubAdminSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required("Full Name is required")
    .min(1)
    .max(100, "Full name must not exceed 100 characters"),
  email: Yup.string()
    .required("Email is required")
    .max(100, "Email must not exceed 100 characters")
    .test(
      "is-valid-email",
      "Invalid email address",
      (value) => !!value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    ),
  phoneNumber: Yup.string().required("Phone Number is required"),
});
